module.exports = __webpack_public_path__ + "static/media/Icon_Digital Content_Grey.67413663.svg";